import {createApp} from "petite-vue";
import Swiper from "swiper";
import {Keyboard, Autoplay, Navigation} from "swiper/modules";
import "./map/map";
import "./map/map-contact";
import SimpleLightbox from "simple-lightbox";

import.meta.glob([ '@images/**' ])
import.meta.env.DEV && import("@styles/main.sass");

interface Header {
    opened: boolean
    handleOpenedHeader(state: boolean): void
}

const headerEl = document.querySelector('[data-header]'),
    headerScope: Header = {
        opened: false,
        handleOpenedHeader(state) {
            document.body.classList.toggle("u-hiddenOverflow", state)
        }
    }

headerEl && createApp(headerScope).mount(headerEl)

document.addEventListener('DOMContentLoaded', () => {

    function animateCount(el: HTMLElement, start: number, end: number, duration: number) {
        let startTimestamp: number | null = null;

        const step = (timestamp: number) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            el.innerText = Math.floor(progress * (end - start) + start).toString();

            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };

        window.requestAnimationFrame(step);
    }

    const numberItems = document.querySelectorAll<HTMLElement>('[data-count]');
    const observerOptions = {
        root: null,
        threshold: 0.7
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const item = entry.target as HTMLElement;
                const endValue = parseInt(item.getAttribute('data-count') || '0', 10);
                animateCount(item, 0, endValue, 3000);

                observer.unobserve(item);
            }
        });
    }, observerOptions);

    numberItems.forEach(item => {
        observer.observe(item);
    });


    //-------------------------------------------------swiper hero
    const swiperHero = new Swiper("[data-hero-swiper]", {
        cssMode: false,
        modules: [Keyboard, Autoplay],
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 30,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        loop: true,
        speed: 500,
        grabCursor: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        allowTouchMove: true,
    });

    //-------------------------------------------------------swiper reference
    const swiperReferences = new Swiper("[data-references-swiper]", {
        modules: [Keyboard, Autoplay, Navigation],
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        centeredSlides: false,
        breakpoints: {

            1023: {
                slidesPerView: 3,
                centeredSlides: true,
                spaceBetween: 20,
            },
        },
        loop: true,
    });
    //-----------------------------------------Swiper-single-article

    const swiperArticle = new Swiper("[data-article-swiper]", {
        cssMode: false,
        modules: [Keyboard, Navigation],
        slidesPerView: 1,

        navigation: {
            nextEl: '.swiper-button-dalsi',
            prevEl: '.swiper-button-predchozi',
        },
        breakpoints: {

            768: {
                slidesPerView: 2,

            }
        },

        grabCursor: true,

        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        allowTouchMove: true,
    });


    //-----------------------------------------------------------Lightbox
    const galleryElement = document.querySelector(".wp-block-gallery");
    if (galleryElement) {
        new SimpleLightbox({
            elements: ".wp-block-gallery .wp-block-image > a",
        });
    }

    //---------------------------------------------------Odkaz na štítky

    const articleTags = document.querySelectorAll('.ArticleCard-tag');

    articleTags.forEach(function(tagElement) {
        const tagUrl = tagElement.dataset.url;
        const tagName = tagElement.innerText.trim();

        if (!tagUrl) return;

        const linkElement = document.createElement('a');
        linkElement.href = tagUrl;
        linkElement.innerText = tagName;

        tagElement.innerHTML = '';
        tagElement.appendChild(linkElement);
    });

    ///_---------------------------------------------------FAQ

    document.querySelectorAll('.Faq-item').forEach((item) => {
        const header = item.querySelector('.Faq-header');
        const content = item.querySelector('.Faq-content') as HTMLElement;

        if (header && content) {
            header.addEventListener('click', () => {
                const isActive = item.classList.toggle('active');
                content.style.maxHeight = isActive ? `${content.scrollHeight}px` : '0';
            });
        }
    });

    const items = document.querySelectorAll('.Faq-item');
        if (items.length > 0) {
            items[items.length - 1].style.marginBottom = '3rem';
        }


});

